<section class="hero inner-pages">
    <div class="base-fit">
        <img src="/assets/images/about/hero.png">
    </div>
    <div class="text-wrapper">
        <h2 [innerHTML]="'about.Who We Are' | translate"></h2>
    </div>
</section>

<div class="page-content">
    <section class="card-with-shadow" data-aos="fade-up">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="row g-3 justify-content-center">
                            <div class="col-lg-5 col-md-5 col-sm-12">
                                <h2>{{'about.About Thrwty' | translate}}</h2>
                                <h1>{{'about.Welcome to Thrwty' | translate}}</h1>
                                <p>{{'about.welcome description' | translate}} </p>
                            </div>
                            <div class="col-lg-1 col-md-1"></div>
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <img src="/assets/images/about/about.png" alt="" width="100%">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="message" data-aos="fade-in">
        <div class="container">
            <div class="row justify-content-center text-center">
                <div class="col-lg-12">
                    <h1 class="section-head">{{'about.Our Mission' | translate}}</h1>
                </div>
                <div class="col-lg-12">
                    <div class="content">
                        <div class="img-card">
                            <img src="/assets/images/about/message.png" alt="">
                            <div class="img-content">
                                <p>{{'about.mission description' | translate}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="numbers" data-aos="fade-in">
        <div class="container">
            <div class="row g-3 justify-content-center text-center">
                <div class="col-lg-11">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 col-sm-4">
                            <h1>{{'about.+500k' | translate}}</h1>
                            <p>{{'about.Job Seeker' | translate}}</p>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4">
                            <h1>{{'about.+70k' | translate}}</h1>
                            <p>{{'about.Job opportunities' | translate}}</p>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4">
                            <h1>{{'about.+30k' | translate}}</h1>
                            <p>{{'about.Recruiters' | translate}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- <section class="team">
        <div class="container">
            <div class="row justify-content-center text-center">
                <div class="col-lg-12">
                    <h1 class="section-head blue">{{'about.Meet the team' | translate}}</h1>
                </div>
            </div>
            <div class="row g-3 justify-content-center text-center">
                <div class="col-lg-3 col-md-3 col-sm-6" *ngFor="let team of teamsList">
                    <div class="card" (mouseover)="selectedTeam = team">
                        <div class="card-image">
                            <img [src]="team.img" alt="">
                        </div>
                        <div class="card-content">
                            <h2>{{team.name_ar}}</h2>
                            <p>{{team.department | translate}}</p>
                            <div class="description">
                                {{team.description_ar}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> -->

</div>
